import React from 'react'
import classNames from 'classnames'
import Tippy from '@tippy.js/react'

import Icon from './icon'
import { getStringChildren, headingTextClassName } from '../util'
import classes from '../styles/typography.module.sass'

export const H0 = ({ Component = 'h1', className, ...props }) => (
    <Headline Component={Component} className={classNames(classes.h0, className)} {...props} />
)
export const H1 = ({ Component = 'h1', className, ...props }) => (
    <Headline Component={Component} className={classNames(classes.h1, className)} {...props} />
)
export const H2 = ({ className, ...props }) => (
    <Headline Component="h2" className={classNames(classes.h2, className)} {...props} />
)
export const H3 = ({ className, ...props }) => (
    <Headline Component="h3" className={classNames(classes.h3, className)} {...props} />
)
export const H4 = ({ className, ...props }) => (
    <Headline Component="h4" className={classNames(classes.h4, className)} {...props} />
)
export const H5 = ({ className, ...props }) => (
    <Headline Component="h5" className={classNames(classes.h5, className)} {...props} />
)

const Permalink = ({ id, children }) =>
    !id ? (
        <span className={headingTextClassName}>{children}</span>
    ) : (
        <a href={`#${id}`} className={classNames(headingTextClassName, classes.permalink)}>
            {children}
        </a>
    )

const Headline = ({
    Component,
    id,
    name,
    tag,
    new: newIn,
    meta,
    icon,
    hidden,
    className,
    children,
}) => {
    // This can be set via hidden="true" and as a prop, so we need to accept both
    if (hidden === true || hidden === 'true') return null
    const tags = tag ? tag.split(',').map(t => t.trim()) : []
    return (
        <Component id={id} name={name} className={classNames(classes.heading, className)}>
            <Permalink id={id}>
                {icon && <Icon name={icon} size="0.75em" />} {children}{' '}
                {meta && <span className={classes.meta}>{meta}</span>}
                {tags.map((t, i) => (
                    <Tag key={i}>{t}</Tag>
                ))}
                {newIn && (
                    <Tooltip
                        small
                        dark
                        content={`This feature is new and was introduced in version ${newIn}`}
                    >
                        <span>
                            <Tag v="new">{newIn}</Tag>
                        </span>
                    </Tooltip>
                )}
            </Permalink>
        </Component>
    )
}

export const Tag = ({ v: variant, children }) => {
    const stringVersion = getStringChildren(children)
    const tagClassNames = classNames(classes.tag, {
        [classes.tagFix]: stringVersion === 'fix',
        [classes.tagDoc]: stringVersion === 'doc',
        [classes.tagNew]: stringVersion === 'new' || variant === 'new',
        [classes.tagFyi]: stringVersion === 'fyi',
    })
    return (
        <span className={tagClassNames}>
            {variant === 'new' && 'New: '}
            {children}
        </span>
    )
}

export const Hr = () => <hr className={classes.hr} />

export const Tooltip = ({ small = false, dark = false, className, children, ...props }) => {
    const tooltipClassNames = classNames(classes.tooltip, className, {
        [classes.tooltipSmall]: !!small,
        [classes.tooltipDark]: !!dark,
    })
    return (
        <Tippy
            animateFill={false}
            distance={small ? 5 : 15}
            placement="bottom"
            className={tooltipClassNames}
            {...props}
        >
            {children}
        </Tippy>
    )
}
